import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-lg-8 mx-auto" }
const _hoisted_2 = { class: "text-center" }

import { ref, onMounted } from "vue";
import WorkflowNavigation from "@/guiide/components/common/WorkflowNavigation.vue";
import ContactUs from "./common/ContactUs.vue";
import PageNav from "@/guiide/components/common/PageNav.vue";
import SubSection from "@/guiide/components/common/SubSection.vue";
import { useStore } from "vuex";
import { workflow } from "../ts/workflow/workflow";
import View from "../ts/view";
import LifeExpectancyBasis from "../ts/lifeExpectancyBasis";
import HealthState from "@/guiide/components/lifeexpectancy/HealthState.vue";
import Survivability from "@/guiide/components/lifeexpectancy/Survivability.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Life',
  setup(__props) {

const store = useStore();
const nextLink = ref("");
let stepCompleted = false;

const usesSurvivabilityForLifeExpectancy = store.state.configuration?.lifeExpectancyBasis == LifeExpectancyBasis.Survival;

onMounted(async () => {
  const nextWorkflowStep = await workflow.getNextWorkflowStep(View.Life);
  nextLink.value = nextWorkflowStep.resource;
});

function registerStepCompletion() {
  stepCompleted = true;
}

async function onNextClicked() {
  if (!stepCompleted) {
    return;
  }

  await workflow.goToNextWorkflowStep();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createVNode(WorkflowNavigation, { workflowStage: "Life" }),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "col-lg-10 mx-auto mb-4" }, [
        _createElementVNode("h2", { class: "skin-page-heading" }, " Have you thought about how long you'll need your retirement savings to last? "),
        _createElementVNode("p", null, " None of us know exactly how long we'll live in retirement, but getting a better idea can help you plan with more confidence. Many people are surprised to learn just how long that might be! ")
      ], -1))
    ]),
    usesSurvivabilityForLifeExpectancy
      ? (_openBlock(), _createBlock(SubSection, {
          key: 0,
          title: "How far might your money need to go?",
          "show-help": false
        }, {
          default: _withCtx(() => [
            _createVNode(Survivability, { onComplete: registerStepCompletion })
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(SubSection, {
          key: 1,
          title: "Your health",
          "show-help": false
        }, {
          default: _withCtx(() => [
            _createVNode(HealthState, { onComplete: registerStepCompletion })
          ]),
          _: 1
        })),
    _createVNode(PageNav, {
      "back-link": "personaldetails",
      onNextClicked: onNextClicked,
      "parent-will-handle-next": true,
      "next-link": nextLink.value
    }, null, 8, ["next-link"]),
    _createVNode(ContactUs, { class: "mt-5" })
  ]))
}
}

})